import { getFallbackValueIfNull } from 'owa-options-core';
import QuickSuggestionsOptionState from '../store/schema/QuickSuggestionsOptionState';
import store from '../store/store';
import { select } from 'satcheljs/lib/legacy';
import {
    getOptionsForFeature,
    SmartSuggestionsOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export interface IsQuickSuggestionsOptionDirtyState {
    optionState: QuickSuggestionsOptionState;
    userOptions: SmartSuggestionsOptions;
}

export default select<IsQuickSuggestionsOptionDirtyState>({
    optionState: () => store,
    userOptions: () =>
        getOptionsForFeature<SmartSuggestionsOptions>(OwsOptionsFeatureType.SmartSuggestions),
})(function isQuickSuggestionsOptionDirty(state?: IsQuickSuggestionsOptionDirtyState) {
    let { optionState, userOptions } = state;

    let smartSuggestionsEnabled = getFallbackValueIfNull(
        optionState.smartSuggestionsEnabled,
        userOptions.smartSuggestionsEnabled
    );
    let browserLocationEnabled = getFallbackValueIfNull(
        optionState.browserLocationEnabled,
        userOptions.browserLocationEnabled
    );

    return (
        smartSuggestionsEnabled !== userOptions.smartSuggestionsEnabled ||
        browserLocationEnabled !== userOptions.browserLocationEnabled
    );
});
